export default {
    //get all ANNOUNCEMENTS
    GET_ANNOUNCEMENTS_REQUEST: 'GET_ANNOUNCEMENTS_REQUEST',
    GET_ANNOUNCEMENTS_SUCCESS: 'GET_ANNOUNCEMENTS_SUCCESS',
    GET_ANNOUNCEMENTS_FAIL: 'GET_ANNOUNCEMENTS_FAIL',

    //edit ANNOUNCEMENT
    EDIT_ANNOUNCEMENT_REQUEST: 'EDIT_ANNOUNCEMENT_REQUEST',
    EDIT_ANNOUNCEMENT_SUCCESS: 'EDIT_ANNOUNCEMENT_SUCCESS',
    EDIT_ANNOUNCEMENT_FAIL: 'EDIT_ANNOUNCEMENT_FAIL',

    //create ANNOUNCEMENT
    CREATE_ANNOUNCEMENT_REQUEST: 'CREATE_ANNOUNCEMENT_REQUEST',
    CREATE_ANNOUNCEMENT_SUCCESS: 'CREATE_ANNOUNCEMENT_SUCCESS',
    CREATE_ANNOUNCEMENT_FAIL: 'CREATE_ANNOUNCEMENT_FAIL',

    DELETE_ANNOUNCEMENT_REQUEST: 'DELETE_ANNOUNCEMENT_REQUEST',
    DELETE_ANNOUNCEMENT_SUCCESS: 'DELETE_ANNOUNCEMENT_SUCCESS',
    DELETE_ANNOUNCEMENT_FAIL: 'DELETE_ANNOUNCEMENT_FAIL',

    //activate ANNOUNCEMENT
    ACTIVATE_ANNOUNCEMENT_REQUEST: 'ACTIVATE_ANNOUNCEMENT_REQUEST',
    ACTIVATE_ANNOUNCEMENT_SUCCESS: 'ACTIVATE_ANNOUNCEMENT_SUCCESS',
    ACTIVATE_ANNOUNCEMENT_FAIL: 'ACTIVATE_ANNOUNCEMENT_FAIL',

    //loading
    ADD_ANNOUNCEMENTS_LOADING: 'ADD_ANNOUNCEMENTS_LOADING'
};

